var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-tooltip',{attrs:{"bottom":"","color":"white","max-width":"400","close-delay":"200"},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-icon',_vm._g(_vm._b({staticClass:"pl-1"},'v-icon',attrs,false),on),[_vm._v("icon-label-questionmark")])]}}])},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }